import { gql } from '@apollo/client';

export interface CreateEventRequest {
  createEventRequest: {
    uuid: string;
    id: string;
  };
}

export const CREATE_EVENT_REQUEST = gql`
  mutation createEventRequest($request: createEventRequestInput!) {
    createEventRequest(data: $request) {
      uuid
      id
    }
  }
`;
